import { render, staticRenderFns } from "./ReporteRegaliaExport.vue?vue&type=template&id=55eea715"
import script from "./ReporteRegaliaExport.vue?vue&type=script&lang=js"
export * from "./ReporteRegaliaExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports